import { Page } from "@/models/page-models/Page";

export const SalesReports: Page = {
  "path": "sales-reports",
  "name": "Sales Reports",
  "props": {
    "data": {
      "title": "Sales Reports",
      "printable": "FALSE",
      "url": "sales-reports",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedActivity",
                  "label": "Select Activity",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyQtStatus",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.staticStatusArrays.data.0.data.qtStatus",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.statusArray"
                      },
                      "name": "copyQtStatus",
                      "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Sales Contract')"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyOrderStatus",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.staticStatusArrays.data.0.data.orderStatus",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.statusArray"
                      },
                      "name": "copyOrderStatus",
                      "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Order')"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetFilters",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultFilters",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "resetFilters"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyInvoiceStatus",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.staticStatusArrays.data.0.data.invoiceStatus",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.statusArray"
                      },
                      "name": "copyInvoiceStatus",
                      "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Invoice')"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyPaymentStatus",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.staticStatusArrays.data.0.data.paymentStatus",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.statusArray"
                      },
                      "name": "copyPaymentStatus",
                      "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Payment Receipt')"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyQtType",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getQtType",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.q",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "copyQtType",
                      "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Sales Contract')"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "[\"Sales Contract\", \"Order\", \"Invoice\", \"Payment Receipt\"]",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "1 (1)",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.q.createdAt.$gte",
                  "label": "Created From",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedActivity}}"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.q.createdAt.$lte",
                  "label": "Created Until",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedActivity}}"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),!==,'Payment Receipt')"
            },
            {
              "name": "1 (2)",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.q.approvedAt.$gte",
                  "label": "Posted From",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.q.approvedAt.$lte",
                  "label": "Posted Until",
                  "disabled": "FALSE"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Payment Receipt')"
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.q.customer",
                  "label": "Select Customer",
                  "disabled": "FALSE",
                  "items": "fetchedData.customer.data",
                  "itemText": "alias",
                  "itemValue": "_id",
                  "multiple": true
                },
                {
                  "type": "dropdown",
                  "variable": "formData.q.status",
                  "label": "Select Status",
                  "disabled": "FALSE",
                  "items": "fetchedData.statusArray",
                  "multiple": true
                },
                {
                  "type": "dropdown",
                  "variable": "formData.q.createdBy",
                  "label": "Created By",
                  "disabled": "FALSE",
                  "items": "fetchedData.users.data",
                  "itemText": "displayName",
                  "itemValue": "_id",
                  "multiple": true
                },
                {
                  "type": "dropdown",
                  "variable": "formData.q.assignedTo",
                  "label": "Select Salesman",
                  "disabled": "FALSE",
                  "items": "fetchedData.users.data",
                  "itemText": "displayName",
                  "itemValue": "_id",
                  "multiple": true
                }
              ],
              "showIf": "{{fetchedData.selectedActivity}}"
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.q.groups",
                  "label": "Sales Group",
                  "disabled": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Payment Receipt')",
                  "showIf": "{{fetchedData.selectedActivity}}",
                  "items": "fetchedData.customerGroups.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "multiple": true
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))"
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "checkbox",
                  "variable": "formData.q.includeTotals",
                  "label": "Load Summary",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),!==,'Order')"
                }
              ],
              "showIf": "{{fetchedData.selectedActivity}}"
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyDefaultPageNo",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultPageNo",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyDefaultPageNo"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getQuotations",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/quotation/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.myQuotations",
                        "arg3Key": "postData",
                        "arg3Value": "formData"
                      },
                      "name": "getQuotations",
                      "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Sales Contract')"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getOrders",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/order/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.orders",
                        "arg3Key": "postData",
                        "arg3Value": "formData"
                      },
                      "name": "getOrders",
                      "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Order')"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getMyInvoices",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.myInvoices",
                        "arg3Key": "postData",
                        "arg3Value": "formData"
                      },
                      "name": "getMyInvoices",
                      "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Invoice')"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getPayments",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice-payment-receipt/search",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "storeInVar",
                        "arg3Value": "fetchedData.invoicePayments"
                      },
                      "name": "getPayments",
                      "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Payment Receipt')"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ],
              "showIf": "{{fetchedData.selectedActivity}}"
            },
            {
              "name": "4b",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Orders Dashboard",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Order')",
                  "items": "fetchedData.orders.data.docs",
                  "headers": [
                    {
                      "value": "_id",
                      "text": "Order #",
                      "type": "url",
                      "width": 80,
                      "url": "/order/{{__item._id}}"
                    },
                    {
                      "value": "customer._id",
                      "text": "Customer ID",
                      "type": "url",
                      "url": "/customers/{{__item.customer._id}}"
                    },
                    {
                      "value": "customer.name",
                      "text": "Customer",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                    },
                    {
                      "value": "__item.customerPO",
                      "text": "Customer PO#"
                    },
                    {
                      "value": "product._id",
                      "text": "Product ID",
                      "type": "url",
                      "url": "/products/{{__item.product._id}}"
                    },
                    {
                      "value": "product",
                      "text": "Product",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "quotationId.createdBy.displayName",
                      "text": "Created By"
                    },
                    {
                      "value": "quantity",
                      "text": "Order Quantity",
                      "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.quantity}})"
                    },
                    {
                      "value": "unit.unit2",
                      "text": "Selling Unit"
                    },
                    {
                      "value": "createdAt",
                      "text": "Order Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})",
                      "width": 100
                    },
                    {
                      "value": "deliveryDate",
                      "text": "Delivery Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveryDate}})",
                      "width": 100,
                      "filterParam": "D-MMM-YY"
                    },
                    {
                      "value": "additionalCharges",
                      "text": "Additional Charges",
                      "type": "formula",
                      "formula": "fn(CONDITIONAL,{{__item.additionalChargesType}},fn(CONCAT,{{__item.additionalChargesType}},:\\n ,fn(HELPER_FN,currency,{{__item.additionalCharges}})),)"
                    },
                    {
                      "value": "status",
                      "text": "Status",
                      "width": 155
                    }
                  ],
                  "tableType": "static",
                  "pagination": {
                    "pageVariable": "formData.page",
                    "serverItemsLengthVariable": "fetchedData.orders.data.totalDocs",
                    "pageChangeFns": [
                      {
                        "executionOrder": 2,
                        "pageFunction": {
                          "name": "getOrders",
                          "type": "fnGetData",
                          "arg1Key": "apiUrl",
                          "arg1Value": "/api/v2/order/search",
                          "arg2Key": "storeInVar",
                          "arg2Value": "fetchedData.orders",
                          "arg3Key": "postData",
                          "arg3Value": "formData"
                        },
                        "name": "getOrders",
                        "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Order')"
                      }
                    ]
                  }
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "groupItems": [
            {
              "name": "4a",
              "pageItems": [
                {
                  "type": "table",
                  "label": "QT Search",
                  "disabled": "FALSE",
                  "items": "fetchedData.myQuotations.data.docs",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "ID",
                      "type": "url",
                      "url": "/view-sales-contract/{{__item._id}}"
                    },
                    {
                      "value": "__item.type",
                      "text": "Type"
                    },
                    {
                      "value": "__item.customer.alias",
                      "text": "Customer Name",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                    },
                    {
                      "value": "__item.customer.assignedTo.displayName",
                      "text": "Created By"
                    },
                    {
                      "value": "customerPO",
                      "text": "PO#"
                    },
                    {
                      "value": "__item.orders",
                      "text": "Total Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                      "width": 100
                    },
                    {
                      "value": "balanceValue",
                      "text": "Balance Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id))"
                    },
                    {
                      "value": "balancePercent",
                      "text": "Balance %",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(HELPER_FN,numFormat,fn(MULTIPLY,fn(DIVIDE,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id)),100),true),%)"
                    },
                    {
                      "value": "__item.dateRange.startDate",
                      "text": "Contract Start",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.startDate}})"
                    },
                    {
                      "value": "__item.dateRange.endDate",
                      "text": "Contract Expiry",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.endDate}})"
                    },
                    {
                      "value": "updatedAt",
                      "text": "Last Updated",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                    },
                    {
                      "value": "__item.status",
                      "text": "Status",
                      "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "pagination": {
                    "pageVariable": "formData.page",
                    "serverItemsLengthVariable": "fetchedData.myQuotations.data.totalDocs",
                    "pageChangeFns": [
                      {
                        "executionOrder": 2,
                        "pageFunction": {
                          "name": "getQuotations",
                          "type": "fnGetData",
                          "arg1Key": "apiUrl",
                          "arg1Value": "/api/v1/quotation/search",
                          "arg2Key": "storeInVar",
                          "arg2Value": "fetchedData.myQuotations",
                          "arg3Key": "postData",
                          "arg3Value": "formData"
                        },
                        "name": "getQuotations",
                        "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Sales Contract')"
                      }
                    ]
                  }
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "label": "QT Summary",
                  "showIf": "{{fetchedData.myQuotations.data.summary}}",
                  "class": "text-h5"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Total Value",
                  "showIf": "{{fetchedData.myQuotations.data.summary.totalValue}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,{{fetchedData.myQuotations.data.summary.totalValue}})"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Sales Contract')"
        },
        {
          "groupItems": [
            {
              "name": "4c",
              "pageItems": [
                {
                  "type": "table",
                  "label": "My Invoices",
                  "disabled": "FALSE",
                  "items": "fetchedData.myInvoices.data.docs",
                  "headers": [
                    {
                      "value": "_id",
                      "text": "Invoice #",
                      "type": "url",
                      "url": "/invoice/{{__item._id}}"
                    },
                    {
                      "value": "customer.name",
                      "text": "Customer",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                    },
                    {
                      "value": "createdAt",
                      "text": "Invoice Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                    },
                    {
                      "value": "total",
                      "text": "Value",
                      "formula": "fn(HELPER_FN,currency,{{__item.total}})"
                    },
                    {
                      "value": "status",
                      "text": "Status"
                    },
                    {
                      "value": "orders.0.id.customerPO",
                      "text": "PO#"
                    }
                  ],
                  "tableType": "static",
                  "pagination": {
                    "pageVariable": "formData.page",
                    "serverItemsLengthVariable": "fetchedData.myInvoices.data.totalDocs",
                    "pageChangeFns": [
                      {
                        "executionOrder": 2,
                        "pageFunction": {
                          "name": "getMyInvoices",
                          "type": "fnGetData",
                          "arg1Key": "apiUrl",
                          "arg1Value": "/api/v1/invoice/search",
                          "arg2Key": "storeInVar",
                          "arg2Value": "fetchedData.myInvoices",
                          "arg3Key": "postData",
                          "arg3Value": "formData"
                        },
                        "name": "getMyInvoices",
                        "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Invoice')"
                      }
                    ]
                  }
                }
              ]
            },
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Invoice Summary",
                  "showIf": "{{fetchedData.myInvoices.data.summary.total}}",
                  "class": "text-h5"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Sub Total",
                  "showIf": "{{fetchedData.myInvoices.data.summary.subtotal}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,{{fetchedData.myInvoices.data.summary.subtotal}})"
                },
                {
                  "type": "label",
                  "label": "VAT Total",
                  "showIf": "{{fetchedData.myInvoices.data.summary.total}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,fn(SUBTRACT,{{fetchedData.myInvoices.data.summary.total}},{{fetchedData.myInvoices.data.summary.subtotal}}))"
                },
                {
                  "type": "label",
                  "label": "Total",
                  "showIf": "{{fetchedData.myInvoices.data.summary.total}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,{{fetchedData.myInvoices.data.summary.total}})"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Invoice')"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "label": "My Invoice Payments",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.invoicePayments.data}}",
                  "items": "fetchedData.invoicePayments.data.docs",
                  "headers": [
                    {
                      "value": "_id",
                      "text": "Payment Id",
                      "type": "url",
                      "url": "/invoice-payment-receipt/{{__item._id}}"
                    },
                    {
                      "value": "customer.alias",
                      "text": "Customer",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                    },
                    {
                      "value": "createdBy.displayName",
                      "text": "Created By"
                    },
                    {
                      "value": "status",
                      "text": "Status"
                    },
                    {
                      "value": "amountReceived",
                      "text": "Amount",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,{{{{__item.amountReceived}} || {{__item.expectedAmountReceived}}}})"
                    },
                    {
                      "value": "approvedAt",
                      "text": "Posting Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.approvedAt}})"
                    }
                  ],
                  "tableType": "static",
                  "pagination": {
                    "pageVariable": "formData.page",
                    "serverItemsLengthVariable": "fetchedData.invoicePayments.data.totalDocs",
                    "pageChangeFns": [
                      {
                        "executionOrder": 2,
                        "pageFunction": {
                          "name": "getPayments",
                          "type": "fnGetData",
                          "arg1Key": "apiUrl",
                          "arg1Value": "/api/v1/invoice-payment-receipt/search",
                          "arg2Key": "postData",
                          "arg2Value": "formData",
                          "arg3Key": "storeInVar",
                          "arg3Value": "fetchedData.invoicePayments"
                        },
                        "name": "getPayments",
                        "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Payment Receipt')"
                      }
                    ]
                  }
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Payments Summary",
                  "showIf": "{{fetchedData.invoicePayments.data.summary}}",
                  "class": "text-h5"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Total Amount Received",
                  "showIf": "{{fetchedData.invoicePayments.data.summary.totalAmountReceived}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,{{fetchedData.invoicePayments.data.summary.totalAmountReceived}})"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedActivity}},'),==,'Payment Receipt')"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAssignableUsers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/businesspartners/assignableUsers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.users"
        },
        "name": "getAssignableUsers"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPageNo",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPageNo",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPageNo"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getStatusArrays",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=qt-order-status",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.staticStatusArrays"
        },
        "name": "getStatusArrays"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomerGroups",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/businesspartnergroups",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerGroups"
        },
        "name": "getCustomerGroups",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))"
      }
    ],
    "functions": [
      {
        "name": "getDefaultPageNo",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": "{}"
        },
        "useFormula": true
      },
      {
        "name": "getQtType",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "type": "Sales Contract"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,CUSTOMER_SERVICE_MANAGER,ACCOUNTING_COSTING,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 40,
  "menuGroup": "Reports"
}